import b from "classnames";
import c, { forwardRef as k, useMemo as u } from "react";
import { IconElement as E } from "../icon-element/icon-element.esm.js";
import { TypographyComponent as I } from "../typography/typography-component.esm.js";
import { useId as N } from "../utils/hooks/useId.esm.js";
import { s as t, B as y } from "../baseinput-BGBS7Rjq.mjs";
import C from "./checkbox-config.esm.js";
const T = k(
  ({
    className: n = "",
    dataTestId: m = "",
    errorMessage: o = "",
    fullWidth: i = !1,
    marginBottom: d = !1,
    style: f,
    componentId: a = null,
    ...p
  }, x) => {
    const s = N(), { errorIcon: r, errorText: e } = C, l = u(() => o ? `${a || s}-${e.className}-${o}` : null, [o, a, s, e.className]), h = b(
      t.checkbox,
      {
        [t["checkbox--full-width"]]: i,
        [t["checkbox--margin-bottom"]]: d
      },
      "fuse-checkbox",
      n
    );
    return /* @__PURE__ */ c.createElement(
      "div",
      {
        className: h,
        "data-testid": m || "fuse-checkbox",
        ref: x,
        style: f
      },
      /* @__PURE__ */ c.createElement(
        y,
        {
          componentId: a || s,
          errorMessageId: l || void 0,
          isError: !!o,
          "data-testid": m,
          ...p
        }
      ),
      o && /* @__PURE__ */ c.createElement("div", { className: `${t.checkboxError} fuse-checkbox__error` }, /* @__PURE__ */ c.createElement(
        E,
        {
          icon: r.icon,
          color: r.color,
          className: t.checkboxErrorIcon,
          dataTestId: r.dataTestId,
          responsiveSize: r.size
        }
      ), /* @__PURE__ */ c.createElement(
        I,
        {
          id: l,
          color: e.color,
          className: t.checkboxErrorText,
          "data-testid": e.dataTestId,
          size: e.size,
          tag: e.tag,
          type: e.type
        },
        o
      ))
    );
  }
);
T.displayName = "Checkbox";
export {
  T as Checkbox
};
